import styled from '@emotion/styled';

export const StyledListItem = styled.li(({ theme }) => ({
    borderBottom: `1px solid ${theme.colors.grey40}`,
}));

export const StyledList = styled.ul(({ theme }) => ({
    padding: `0 ${theme.space[3]}`,
}));
